$(document).ready(function() {
  // var _learnq = _learnq || [];
  //       var classname = document.getElementsByClassName("klaviyo-addtocart_form-event btn");
  //       var addToCart = function() {
  //       _learnq.push(['track', 'Added to Cart', item]);
  //         console.log('added to cart');
  //       }; for (var i = 0; i < classname.length; i++) {
  //       classname[i].addEventListener('click', addToCart, false);
  //       }

  var swiperThumb = new Swiper("#product_thumbnails", {
      spaceBetween: 10,
      slidesPerView: 5,
      // simulateTouch: true,
      scrollbar: {
        draggable: true,
      },
    });

  var swiperFeatured = new Swiper("#product_media_mobile", {
      slidesPerView: 1.15,
      spaceBetween: 15,
      thumbs: {
        swiper: swiperThumb,
      },
      on: {
        realIndexChange: (swiper) => {
          if(swiper.realIndex != 0) {
            $('#featured_stickers').hide();
          }else {
            $('#featured_stickers').show();
          }
        }
      },
    });

  window.reInitSwiper = function (e) {
    swiperThumb = new Swiper("#product_thumbnails", {
      spaceBetween: 10,
      slidesPerView: 5,
      // simulateTouch: true,
    });

    swiperFeatured = new Swiper("#product_media_mobile", {
      slidesPerView: 1.15,
      spaceBetween: 15,
      thumbs: {
        swiper: swiperThumb,
      },
      on: {
        realIndexChange: (swiper) => {
          if(swiper.realIndex != 0) {
            $('#featured_stickers').hide();
          }else {
            $('#featured_stickers').show();
          }
        }
      },
    });
  }


  Fancybox.bind("[data-fancybox]", {
    Thumbs: {
      type: "classic",
    },
  });

  $('#slide3').click(swiperFeatured,function(){
      swiperFeatured.slideTo(swiperFeatured.slides.length -1);
  });

  // swiperFeatured.on('transitionEnd', function () {
  //   console.log('slide changed' + swiperThumb.realIndex);
  // });


  // var swiperFeatured = new Swiper("#product_media_mobile", {
  //     spaceBetween: 5,
  //     slidesPerView: 1,
  //   });

  $('#product_media_mobile .swiper-wrapper .swiper-slide').remove();
  function loadInitialImages() {
    console.log('loadInitialImages');
    swiperFeatured.updateSlides();
    swiperThumb.updateSlides();
    $('#product_media_main_desktop .desktop-grid-wrapper .desktop-grid-blocks').remove();
    let initial_image = '';
    if ($(".swatch div.swatch-element input[name='option-1']:checked").length) {
      initial_image = $(".swatch div.swatch-element input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    }
    let mediaJson = $('.media_slider').data('media-json');
    let mediaLength = $('.media_slider').data('media-length');

    // mobile thumbnails
    const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');
    // desktop grid boxes .appendTo(this);
    const desktop_grid_blocks = $('#product_media_main_desktop .desktop-grid-wrapper');

    var checked_variant_size = false;
     if($('body').attr('id') === 'desk-mat' || $('body').attr('id').includes('orbitkey-desk-mat') || $('body').attr('id').includes('hybrid-laptop-sleeve') || $('body').attr('id').includes('compendium')  ) {
        if ($(".product-details-wrapper input[name='option-2']").length) {
          //console.log('is option 2: ' + $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-'));
          var checked_variant_size = $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
        }
      }
      if(checked_variant_size){
        //initial_image = initial_image+'-'+checked_variant_size;
      }
    if ($(".product-details-wrapper input[name='option-2']").length) {
      //console.log('is option 2: ' + $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-'));
      var option_2 = $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
      if (option_2) {
        initial_image = initial_image+'-'+option_2;
      }
    }

    let z = 0;
    for(let i = 0; i < mediaLength; i++) {
        let currentMedia = mediaJson[i + 1];
        if(currentMedia.media_type === 'image') {
              // if(currentMedia.src.indexOf(initial_image) !== -1) {
              if( (currentMedia.alt && currentMedia.alt.split('|')[0] == initial_image) || !currentMedia.alt || currentMedia.alt == 'all' ) {
                $featuredSlider = $(`<div class="swiper-slide"><div class="product-medias__media"></div></div>`);
                $featuredSlider.find('.product-medias__media').append(`<img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" loading=lazy>`);
                if (currentMedia.alt && currentMedia.alt.split('|').length > 1) {
                  $featuredSlider.find('.product-medias__media').append(`<span class="image-description">`+currentMedia.alt.split('|')[1]+`</span>`);
                }
                swiperFeatured.appendSlide($featuredSlider);

                $featuredThumb = $(`<div class="swiper-slide product-thumbs-slides"><div class="responsive-image-product-wrapper"></div></div>`);
                $featuredThumb.find('.responsive-image-product-wrapper').append(`<img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}">`);
                swiperThumb.appendSlide($featuredThumb);
                
                $featuredDesktop = $(`<div class="desktop-grid-blocks"><a href="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" data-fancybox="gallery"></a></div>`)
                $featuredDesktop.find('a').append(`<img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" data-thumbnail-id="${z}">`);
                if (currentMedia.alt && currentMedia.alt.split('|').length > 1) {
                  $featuredDesktop.find('a').append(`<span class="image-description">`+currentMedia.alt.split('|')[1]+`</span>`);
                }
                $featuredDesktop.appendTo(desktop_grid_blocks);
                z++;
              }
        }

        if(currentMedia.media_type === 'video') {
          // console.log(currentMedia.preview_image.src);
          $featuredVideo = $(`<div class="desktop-grid-blocks"></div>`);
          $featuredVideo.append(`<video width="100%" height="100%" poster="${currentMedia.preview_image.src.includes('.jpg') ? currentMedia.preview_image.src.replace('.jpg', '_200x200.jpg') : currentMedia.preview_image.src.replace('.png', '_200x200.png')}" playsinline autoplay muted loop><source src="${currentMedia.sources[0].url}" type="video/mp4"></video>`);
          if (currentMedia.alt && currentMedia.alt.split('|').length > 1) {
            $featuredVideo.append(`<span class="image-description">`+currentMedia.alt.split('|')[1]+`</span>`);
          }
          $featuredVideo.appendTo(desktop_grid_blocks);

          $featuredSlider = $(`<div class="swiper-slide"><div class="video-inner-wrapper"></div></div>`);
          $featuredSlider.find('.video-inner-wrapper').append(`<video width="100%" height="100%" playsinline autoplay muted loop><source src="${currentMedia.sources[0].url}" type="video/mp4"></video>`);
          if (currentMedia.alt && currentMedia.alt.split('|').length > 1) {
            $featuredSlider.find('.video-inner-wrapper').append(`<span class="image-description">`+currentMedia.alt.split('|')[1]+`</span>`);
          }
          swiperFeatured.appendSlide($featuredSlider);

          $featuredThumb = $(`<div class="swiper-slide product-thumbs-slides"><div style="height:100%" class="responsive-image-product-wrapper"></div></div>`);
          $featuredThumb.find('.responsive-image-product-wrapper').append(`<img src="${currentMedia.preview_image.src.includes('.jpg') ? currentMedia.preview_image.src.replace('.jpg', '_200x200.jpg') : currentMedia.preview_image.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}">`);
          swiperThumb.appendSlide($featuredThumb);
          z++;
        }

    }
  }
  loadInitialImages();
  setTimeout(function(){
    if($('.product-single-wrapper .swatch .color.swatch-element input:checked+label').length) {
      $('.product-single-wrapper .swatch .color.swatch-element input:checked+label')[0].click();
    }
  },50);

  $(".swatch div.swatch-element:not(.bundle-default)").unbind('click');
  $(".swatch div.swatch-element:not(.bundle-default)").click(function() {
    const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');
    const swatch_wrapper = $(this).closest('.swatch');
    const swatch_header = $(this).closest('.swatch').find('.color-switch-header');
    const swatch_index = parseInt(swatch_wrapper.data('option-index')) + 1;
    $('#product_thumbnails .swiper-wrapper .swiper-slide').remove();
    $('#product_media_mobile .swiper-wrapper .swiper-slide').remove();
    loadInitialImages();
    swatch_header.html(swatch_header.data('swatch') + ': ' + $("input[name='option-"+swatch_index+"']:checked").val());
  });

  // const lettersOnlyInput = $('#bold_options_div .tb_2002472_327268');

  $("body").on("click","#bold_options_div .bold_option_radio input:radio", function(e) {
    $('.bold_option_value_title').css({'backgroundColor': '#fff','color': '#000'});
    if(this.value != 'No') {
      $('#AddToCart.bold_clone').prop('disabled',true);
      $('#AddToCart.bold_clone').css({ opacity: 0.6 });
      $(this).parent().parent().find('.bold_option_value_title').css({'backgroundColor': '#000','color': '#fff'});
    } else {
      $('#AddToCart.bold_clone').prop('disabled',false);
      $('#AddToCart.bold_clone').css({ opacity: 1 });
      $(this).parent().parent().find('.bold_option_value_title').css({'backgroundColor': '#000','color': '#fff'});
    }

    // IF THIS MONOGRAMMING IS INSIDE EXTENSION, CHANGE THE TITLE
    if( $(this).closest('.product-extension-wrapper').length ) {
      var extensionWrapper = $(this).closest('.product-extension-wrapper')[0];
      var productHeader = extensionWrapper.querySelector('.product-extension-item__product-inner-top');
      if(this.value != 'No') {
        productHeader.classList.add('selected');
        setTimeout(function(){
          var price = '';
          var boldVariant = document.querySelector('[name="properties[_boldVariantPrices]"]');
          var boldVariantPrice = 0;
          if(boldVariant) {
            boldVariantPrice = parseFloat(parseInt(boldVariant.value)/100);
          }
          price = '$' + boldVariantPrice.toFixed(2) + ' AUD';
          if(productHeader.querySelector('.product-extension-item__product-price .money')) {
            productHeader.querySelector('.product-extension-item__product-price .money').textContent = price;
          }

          const inputField = document.querySelector('input[name="properties[Initials (Capital letters only)*]"]');
          if (inputField) {
            // Clone the element without its listeners
            const clonedField = inputField.cloneNode(true);
            // Replace the original element with the clone
            inputField.parentNode.replaceChild(clonedField, inputField);
            // Add any desired listeners to the cloned element
            clonedField.addEventListener('keydown', function(event) {
              if (event.key === 'Enter') {
                event.preventDefault();
              }
            });
          }

        },50);
      } else {
        productHeader.classList.remove('selected');
      }
    }

    // IF THIS MONOGRAMMING IS INSIDE EXTENSION, CALCULATE THE EXTENSION HEIGHT
    if( $(this).closest('.product-extension-item__product-inner-bottom').length ) {
      var content = $(this).closest('.product-extension-item__product-inner-bottom')[0];
      setTimeout(function(){
        content.style.height = $(content).find('#bold_options_div').outerHeight(true) + "px";
        content.style.maxHeight = $(content).find('#bold_options_div').outerHeight(true) + "px";
      },5);
    }

    // CALCULATE EXTENSION TOTAL PRICE
    setTimeout(function(){
      //console.log($('[name="properties[_boldVariantPrices]"]').val());
      window.extensionTotal();
      window.stickyAddToCartBar();
    },50);
  });

  $("body").on("keyup","#bold_options_div .bold_option_element input", function(e) {
    this.value = this.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
    var key = e.keyCode;
      if (key >= 48 && key <= 57) {
          e.preventDefault();
      }

    if(this.value.length < 1) {
      $('#AddToCart.bold_clone').prop('disabled',true);
      $('#AddToCart.bold_clone').css({ opacity: 0.6 });
    } else {
      $('#AddToCart.bold_clone').prop('disabled',false);
      $('#AddToCart.bold_clone').css({ opacity: 1 });
    }
  });

  var _carousel_swiper = new Swiper(".owl-carousel-desk-mat-compare", {
      spaceBetween: 0,
      slidesPerView: 3,
      loop: false,
      dots: false,
      breakpoints: {
        0:{
            slidesPerView:1,
            spaceBetween:0,
        },
        600:{
            slidesPerView:1,
			spaceBetween:10,
        },
        769:{
            slidesPerView:1,
			spaceBetween:10,
        },
        1000:{
            slidesPerView:3,
			spaceBetween:0,
        }
      }

      // simulateTouch: true,
    });



  if($('.desk-mat-compare-buttons .swatch-element').length) {
    $('.desk-mat-compare-buttons .swatch-element').click(function() {
      const _this = $(this);
      let sizeSwatch = $('.desk-mat-compare-buttons input[type="radio"]:checked');
	  // If swatches are checked
      if(sizeSwatch.length) {
        if(sizeSwatch.val() == 1) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');
        } else if(sizeSwatch.val() == 2) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").toggleClass('hide');
        } else {
           $(".owl-carousel-desk-mat-compare[data-slider-id='0'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');
        }
      } else {
       $('.desk-mat-compare-buttons input[type="radio"]').first().prop("checked", true);
      }
    });
   }

});
